var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageContentMargin pageBigMarginBottom"},[_c('VTitle',{attrs:{"val":_vm.title,"showAll":_vm.showAll,"showLine":_vm.show}}),_c('div',{staticClass:"pageUserShadow msgCard"},[_vm._t("form"),(_vm.show)?_c('KBtn',{attrs:{"size":"big","title":_vm.btnText,"color":"var(--redColor)"},on:{"click":_vm.onClick}}):_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }